import React from 'react'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '../../hooks/useEditor'

export const defaultProps = {}

export const dynamicProps = []

export const ROOT = withBlock(
  (props) => {
    const { isSSR, children } = props

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref, 'connect')}
        className={(enabled ? 'ROOT--editing ' : '') + props.className}
        onDoubleClick={props.onDoubleClick}
      >
        {children}
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

ROOT.craft = withCraft({
  name: 'ROOT',
  defaultProps,
  settings: null,
})
